import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../component/Button';
import SupplierSelector from '../component/SupplierSelector';
import SupplierSiteSelector from '../component/SupplierSiteSelector';
import SupplierContext from '../context/supplier/supplierContext';
import MaterialContext from '../context/material/materialContext';
import AlertContext from '../context/alert/alertContext';
import Alert from '../component/Alert';
import Spinner from '../component/Spinner';

const BookInSite = props => {
  const supplierContext = useContext(SupplierContext);
  const materialContext = useContext(MaterialContext);
  const alertContext = useContext(AlertContext);

  const { setAlert } = alertContext;
  const {  loading, getPendingBookIns, pendingBookIns, getConfirmedBookIns, confirmedBookIns, createBookIn, setCurrentBookIn, supplierSite } =
    materialContext;

  const { selectedSupplier } = supplierContext;

  // create book in number
  const createBookinSubmit = async () => {
    if (selectedSupplier.id) {
      await createBookIn(
        selectedSupplier.id,
      );
      await props.history.push(`/material/bookindetails`);
    } else {
      setAlert(` Please choose/fill in data`, 'warning');
    }
  };

  const [listType, setListType] = useState("pending"); // for tracking the list type

  const toggleListType = () => {
    setListType(prevType => (prevType === "pending" ? "confirmed" : "pending"));
  };

  const bookInsList = listType === "pending" ? pendingBookIns : confirmedBookIns;

  useEffect(() => {
    if (selectedSupplier && supplierSite) {
      getPendingBookIns(selectedSupplier.id, supplierSite.id);
      getConfirmedBookIns(selectedSupplier.id, supplierSite.id);
    };
    // eslint-disable-next-line
  }, [selectedSupplier, supplierSite]);

  return (
    <>
      <Alert />
      <div className="container">
        <div className="material">
          {loading ? (
            <Spinner />
          ) : (
            <div className="text-center">
              <SupplierSelector proc="btn-mat" />
              {!selectedSupplier ? null : (
                <div className="">
                  <SupplierSiteSelector proc="mat" supplierId={selectedSupplier.id} />
                  {!supplierSite ? null : (
                    <>
                      <div>
                        <Button
                          text="Create Book-In"
                          className="btn btn-mat"
                          onClick={() => {
                              createBookinSubmit(selectedSupplier.id);
                          }}
                        />
                      </div>
                      <hr />
                      <Button
                        text={`${listType === "pending" ? "Pending" : "Confirmed"} Book-ins on ${supplierSite.name}`}
                        icon={<i className="fa-solid fa-arrows-rotate"></i>}
                        className="btn btn-mat"
                        onClick={toggleListType}
                      />
                    {!bookInsList ? null: (
                      <div>
                        <p>{listType === "pending" ? "Pending" : "Confirmed"} Book-Ins</p>
                        <hr />
                        <div className="list">
                        {bookInsList.map(bookIn => (
                          <div
                              key={bookIn.name}
                              className="list-item"
                              onClick={async ()  => {
                                  await setCurrentBookIn(bookIn);
                                  props.history.push(`/material/bookindetails`);
                              }}
                          >
                              {bookIn.name}
                          </div>
                        ))}
                        </div>
                      </div>)
                    }
                    </>
                  )}
                  
                  </div>
              )}
            </div>
          )}
          <div className="text-center">
            <Link to="/">
              <Button text="Back" className="btn btn-mat" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookInSite;
